import React from 'react';

import {
  CmDatePicker,
  CmFlex,
  CmFormControl,
  CmFormLabel,
  CmSelectDigitsTime,
  CmText,
} from '@/components/uiParts';

interface Props {
  label: string;
  startDate: Date;
  setStartDate: (date: Date) => void;
  endDate: Date;
  setEndDate: (date: Date) => void;
  maxDate?: Date;
  minDate?: Date;
}

export const DateTimeRangeForm: React.VFC<Props> = ({
  label,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  maxDate,
  minDate,
}) => {
  const handleChangeStartHour = (hour: string) => {
    const newDate = new Date(startDate);
    newDate.setHours(Number(hour));
    setStartDate(newDate);
  };

  const handleChangeStartMinutes = (minutes: string) => {
    const newDate = new Date(startDate);
    newDate.setMinutes(Number(minutes));
    setStartDate(newDate);
  };

  const handleChangeEndHour = (hour: string) => {
    const newDate = new Date(endDate);
    newDate.setHours(Number(hour));
    setEndDate(newDate);
  };

  const handleChangeEndMinutes = (minutes: string) => {
    const newDate = new Date(endDate);
    newDate.setMinutes(Number(minutes));
    setEndDate(newDate);
  };

  return (
    <CmFormControl width="auto">
      <CmFormLabel mr={2} mb={0} fontWeight={'bold'}>
        {label}
      </CmFormLabel>
      <CmFlex align="center">
        <CmFlex align="center">
          <CmFlex align="center" mr={2}>
            <CmFlex mr={2}>
              <CmDatePicker
                selected={startDate}
                onChange={setStartDate}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                minDate={minDate}
                maxDate={endDate}
                dateFormat="yyyy/MM/dd"
              />
            </CmFlex>
            <CmSelectDigitsTime
              date={startDate}
              handleChangeHour={handleChangeStartHour}
              handleChangeMinutes={handleChangeStartMinutes}
            />
          </CmFlex>

          <CmText>〜</CmText>

          <CmFlex align="center" ml={2}>
            <CmFlex mr={2}>
              <CmDatePicker
                selected={endDate}
                onChange={setEndDate}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                maxDate={maxDate}
                dateFormat="yyyy/MM/dd"
              />
            </CmFlex>
            <CmSelectDigitsTime
              date={endDate}
              handleChangeHour={handleChangeEndHour}
              handleChangeMinutes={handleChangeEndMinutes}
            />
          </CmFlex>
        </CmFlex>
      </CmFlex>
    </CmFormControl>
  );
};
